"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.staticRenderFns = exports.render = void 0;
var render = exports.render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c("div", [_c("el-form", {
    ref: "regForm",
    attrs: {
      model: _vm.regForm,
      rules: _vm.regRules
    }
  }, [_c("el-form-item", {
    attrs: {
      prop: "validatePhone"
    }
  }, [_c("el-input", {
    attrs: {
      type: "phone",
      autocomplete: "off",
      clearable: true,
      placeholder: "手机号",
      maxlength: "11"
    },
    model: {
      value: _vm.regForm.validatePhone,
      callback: function callback($$v) {
        _vm.$set(_vm.regForm, "validatePhone", $$v);
      },
      expression: "regForm.validatePhone"
    }
  }, [_c("img", {
    staticClass: "margin-left-5 width-21",
    attrs: {
      slot: "prefix",
      src: "https://whbj-yellowpage.oss-cn-shenzhen.aliyuncs.com/H5_vue3/%E6%96%B0%E5%AE%98%E7%BD%91/lQLPKIGh3DfINEEZFLBNn4hZwTu9ewmspXF3gJsB_20_25.png"
    },
    slot: "prefix"
  })])], 1), _c("el-form-item", {
    staticClass: "code_con",
    attrs: {
      prop: "validateCode"
    }
  }, [_c("el-input", {
    attrs: {
      type: "messagecode",
      autocomplete: "off",
      clearable: true,
      placeholder: "短信验证码"
    },
    nativeOn: {
      keyup: function keyup($event) {
        if (!$event.type.indexOf("key") && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) return null;
        return _vm.toReg("regForm");
      }
    },
    model: {
      value: _vm.regForm.validateCode,
      callback: function callback($$v) {
        _vm.$set(_vm.regForm, "validateCode", $$v);
      },
      expression: "regForm.validateCode"
    }
  }, [_c("template", {
    slot: "append"
  }, [_c("div", {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: _vm.codeBtnShow,
      expression: "codeBtnShow"
    }],
    staticClass: "color-3269F6",
    attrs: {
      slot: "reference"
    },
    on: {
      click: _vm.toGetCode
    },
    slot: "reference"
  }, [_vm._v("获取验证码")]), _c("div", {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: !_vm.codeBtnShow,
      expression: "!codeBtnShow"
    }],
    staticClass: "count"
  }, [_c("span", [_vm._v(_vm._s(_vm.count))]), _vm._v(" s")])]), _c("div", {
    staticClass: "min-height-full flex-col-center",
    attrs: {
      slot: "prefix"
    },
    slot: "prefix"
  }, [_c("img", {
    staticClass: "margin-left-5 width-21",
    attrs: {
      src: "https://whbj-yellowpage.oss-cn-shenzhen.aliyuncs.com/H5_vue3/%E6%96%B0%E5%AE%98%E7%BD%91/%E9%AA%8C%E8%AF%81%E7%A0%81.png"
    }
  })])], 2)], 1), _c("div", {
    staticClass: "toReg agreement-row text-left margin-top-30"
  }, [_c("el-checkbox", {
    model: {
      value: _vm.agreementChecked,
      callback: function callback($$v) {
        _vm.agreementChecked = $$v;
      },
      expression: "agreementChecked"
    }
  }, [_c("span", [_vm._v("我已阅读并同意")]), _c("el-link", {
    attrs: {
      type: "primary",
      underline: false
    },
    on: {
      click: function click($event) {
        $event.stopPropagation();
        _vm.$root.innerVisible = true;
      }
    }
  }, [_vm._v("《用户协议》")]), _c("span", [_vm._v("、")]), _c("el-link", {
    attrs: {
      type: "primary",
      underline: false
    },
    on: {
      click: function click($event) {
        $event.stopPropagation();
        return _vm.toPrivacy.apply(null, arguments);
      }
    }
  }, [_vm._v("《隐私政策》")]), _c("span", [_vm._v("和")]), _c("el-link", {
    attrs: {
      type: "primary",
      underline: false
    },
    on: {
      click: function click($event) {
        $event.stopPropagation();
        return _vm.toShippingInstructions.apply(null, arguments);
      }
    }
  }, [_vm._v("《运输须知》")]), _c("span", [_vm._v("；未注册的手机号将自动注册")])], 1)], 1), _c("el-form-item", [_c("el-button", {
    staticClass: "login_btn",
    attrs: {
      type: "primary",
      disabled: _vm.submitDisabled || !_vm.agreementChecked
    },
    on: {
      click: function click($event) {
        return _vm.toReg("regForm");
      }
    }
  }, [_vm._v("登录")])], 1), _c("el-dialog", {
    attrs: {
      title: "图片验证码",
      visible: _vm.showPopup,
      width: "20%",
      "before-close": _vm.handleClose,
      "append-to-body": true,
      "close-on-click-modal": false
    },
    on: {
      "update:visible": function updateVisible($event) {
        _vm.showPopup = $event;
      }
    }
  }, [_c("el-form-item", {
    staticClass: "code_con code_conCaptcha",
    attrs: {
      prop: "captcha"
    }
  }, [_c("el-input", {
    attrs: {
      autocomplete: "off",
      clearable: true,
      placeholder: "请输入图片验证码"
    },
    scopedSlots: _vm._u([{
      key: "prefix",
      fn: function fn() {
        return [_c("img", {
          staticClass: "input-icon",
          attrs: {
            src: require("../../assets/static/img/login/03.png"),
            alt: "图标"
          }
        })];
      },
      proxy: true
    }, {
      key: "append",
      fn: function fn() {
        return [_c("img", {
          staticClass: "captcha-img",
          attrs: {
            src: _vm.yamImg,
            alt: "验证码"
          }
        })];
      },
      proxy: true
    }]),
    model: {
      value: _vm.regForm.captcha,
      callback: function callback($$v) {
        _vm.$set(_vm.regForm, "captcha", $$v);
      },
      expression: "regForm.captcha"
    }
  })], 1), _c("span", {
    staticClass: "dialog-footer",
    attrs: {
      slot: "footer"
    },
    slot: "footer"
  }, [_c("el-button", {
    on: {
      click: function click($event) {
        _vm.showPopup = false;
      }
    }
  }, [_vm._v("取 消")]), _c("el-button", {
    attrs: {
      type: "primary"
    },
    on: {
      click: _vm.changeShowPopup
    }
  }, [_vm._v("确 定")])], 1)], 1), _c("el-dialog", {
    attrs: {
      title: _vm.agreementDialogTitle,
      visible: _vm.agreementDialogVisible,
      width: "70%",
      top: "5vh",
      center: "",
      "append-to-body": true,
      "close-on-click-modal": false
    },
    on: {
      "update:visible": function updateVisible($event) {
        _vm.agreementDialogVisible = $event;
      }
    }
  }, [_vm.agreementDialogVisible ? _c("iframe", {
    staticClass: "agreement-document-frame",
    attrs: {
      src: _vm.agreementDialogUrl,
      title: _vm.agreementDialogTitle
    }
  }) : _vm._e()])], 1), _c("div", {
    staticClass: "app-download"
  }, [_vm._v("APP下载")])], 1);
};
var staticRenderFns = exports.staticRenderFns = [];
render._withStripped = true;